import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MetaNewCampaign = () => {
  const history = useHistory();
  const { token: authToken, userLanguage } = useSelector((state) => state.auth);
  const metaCampaignTranslations = {
    pleaseSelectRequired: {
      en: "Please select account/catalog/product and campaign name",
      fr: "Veuillez selectionner un compte/catalogue/produit et un nom de campagne",
      es: "Selecciona cuenta/catalogo/producto y nombre de campana",
      zh: "请选择账户/目录/产品并填写广告活动名称",
      pt: "Selecione conta/catalogo/produto e nome da campanha",
      ar: "يرجى اختيار الحساب/الكتالوج/المنتج واسم الحملة",
    },
    campaignCreated: {
      en: "Campaign created",
      fr: "Campagne creee",
      es: "Campana creada",
      zh: "广告活动已创建",
      pt: "Campanha criada",
      ar: "تم إنشاء الحملة",
    },
    campaignCreateFailed: {
      en: "Campaign creation failed",
      fr: "La creation de la campagne a echoue",
      es: "Fallo la creacion de la campana",
      zh: "创建广告活动失败",
      pt: "Falha na criacao da campanha",
      ar: "فشل إنشاء الحملة",
    },
    draftSaved: {
      en: "Draft saved",
      fr: "Brouillon enregistre",
      es: "Borrador guardado",
      zh: "草稿已保存",
      pt: "Rascunho salvo",
      ar: "تم حفظ المسودة",
    },
    draftSaveFailed: {
      en: "Failed to save draft",
      fr: "Echec de l'enregistrement du brouillon",
      es: "Error al guardar el borrador",
      zh: "保存草稿失败",
      pt: "Falha ao salvar rascunho",
      ar: "فشل حفظ المسودة",
    },
    pageTitle: {
      en: "Attribute Orders - New Campaign",
      fr: "Commandes d'attribution - Nouvelle campagne",
      es: "Ordenes de atribucion - Nueva campana",
      zh: "属性订单 - 新建广告活动",
      pt: "Pedidos de atribuicao - Nova campanha",
      ar: "طلبات الإسناد - حملة جديدة",
    },
    adAccount: {
      en: "Ad account (catalog connected)",
      fr: "Compte publicitaire (catalogue connecte)",
      es: "Cuenta publicitaria (catalogo conectado)",
      zh: "广告账户（已连接目录）",
      pt: "Conta de anuncios (catalogo conectado)",
      ar: "حساب الإعلانات (الكتالوج متصل)",
    },
    productFromCatalog: {
      en: "Product (from selected Meta catalog)",
      fr: "Produit (du catalogue Meta selectionne)",
      es: "Producto (del catalogo Meta seleccionado)",
      zh: "产品（来自所选Meta目录）",
      pt: "Produto (do catalogo Meta selecionado)",
      ar: "المنتج (من كتالوج ميتا المحدد)",
    },
    loadingCatalogProducts: {
      en: "Loading catalog products...",
      fr: "Chargement des produits du catalogue...",
      es: "Cargando productos del catalogo...",
      zh: "正在加载目录产品...",
      pt: "Carregando produtos do catalogo...",
      ar: "جارٍ تحميل منتجات الكتالوج...",
    },
    selectProduct: {
      en: "-- Select product --",
      fr: "-- Selectionner un produit --",
      es: "-- Seleccionar producto --",
      zh: "-- 选择产品 --",
      pt: "-- Selecionar produto --",
      ar: "-- اختر منتجًا --",
    },
    campaignName: {
      en: "Campaign name",
      fr: "Nom de la campagne",
      es: "Nombre de la campana",
      zh: "广告活动名称",
      pt: "Nome da campanha",
      ar: "اسم الحملة",
    },
    dailyBudget: {
      en: "Daily budget (USD)",
      fr: "Budget quotidien (USD)",
      es: "Presupuesto diario (USD)",
      zh: "每日预算（USD）",
      pt: "Orcamento diario (USD)",
      ar: "الميزانية اليومية (USD)",
    },
    ageMin: {
      en: "Age min",
      fr: "Age minimum",
      es: "Edad minima",
      zh: "最小年龄",
      pt: "Idade minima",
      ar: "الحد الأدنى للعمر",
    },
    ageMax: {
      en: "Age max",
      fr: "Age maximum",
      es: "Edad maxima",
      zh: "最大年龄",
      pt: "Idade maxima",
      ar: "الحد الأقصى للعمر",
    },
    locations: {
      en: "Locations (comma-separated country codes)",
      fr: "Localisations (codes pays separes par des virgules)",
      es: "Ubicaciones (codigos de pais separados por comas)",
      zh: "位置（以逗号分隔的国家代码）",
      pt: "Localizacoes (codigos de pais separados por virgula)",
      ar: "المواقع (رموز الدول مفصولة بفواصل)",
    },
    startDate: {
      en: "Start date (optional)",
      fr: "Date de debut (optionnel)",
      es: "Fecha de inicio (opcional)",
      zh: "开始日期（可选）",
      pt: "Data de inicio (opcional)",
      ar: "تاريخ البدء (اختياري)",
    },
    endDate: {
      en: "End date (optional)",
      fr: "Date de fin (optionnel)",
      es: "Fecha de fin (opcional)",
      zh: "结束日期（可选）",
      pt: "Data de termino (opcional)",
      ar: "تاريخ الانتهاء (اختياري)",
    },
    landingUrl: {
      en: "Landing URL (optional)",
      fr: "URL de destination (optionnel)",
      es: "URL de destino (opcional)",
      zh: "落地页URL（可选）",
      pt: "URL de destino (opcional)",
      ar: "رابط الصفحة المقصودة (اختياري)",
    },
    creating: {
      en: "Creating...",
      fr: "Creation...",
      es: "Creando...",
      zh: "创建中...",
      pt: "Criando...",
      ar: "جارٍ الإنشاء...",
    },
    createCampaign: {
      en: "Create campaign",
      fr: "Creer une campagne",
      es: "Crear campana",
      zh: "创建广告活动",
      pt: "Criar campanha",
      ar: "إنشاء حملة",
    },
    saving: {
      en: "Saving...",
      fr: "Enregistrement...",
      es: "Guardando...",
      zh: "保存中...",
      pt: "Salvando...",
      ar: "جارٍ الحفظ...",
    },
    saveDraft: {
      en: "Save draft",
      fr: "Enregistrer le brouillon",
      es: "Guardar borrador",
      zh: "保存草稿",
      pt: "Salvar rascunho",
      ar: "حفظ المسودة",
    },
    back: {
      en: "Back",
      fr: "Retour",
      es: "Atras",
      zh: "返回",
      pt: "Voltar",
      ar: "رجوع",
    },
    catalogLabel: {
      en: "Catalog",
      fr: "Catalogue",
      es: "Catalogo",
      zh: "目录",
      pt: "Catalogo",
      ar: "الكتالوج",
    },
    untitled: {
      en: "Untitled",
      fr: "Sans titre",
      es: "Sin titulo",
      zh: "未命名",
      pt: "Sem titulo",
      ar: "بدون عنوان",
    },
    retailerId: {
      en: "retailer_id",
      fr: "retailer_id",
      es: "retailer_id",
      zh: "retailer_id",
      pt: "retailer_id",
      ar: "retailer_id",
    },
  };
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [catalogProducts, setCatalogProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [savingDraft, setSavingDraft] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    name: "",
    productRetailerId: "",
    productMetaId: "",
    dailyBudget: 10,
    ageMin: 18,
    ageMax: 65,
    locations: "US",
    catalogLandingUrl: "",
    startDate: "",
    endDate: "",
  });

  const headers = () => ({ Authorization: `Bearer ${authToken}` });
  const ev = (e) => (e && e.target ? e.target.value : "");

  useEffect(() => {
    if (!authToken) return;
    axios
      .get("/ad-accounts", { headers: headers() })
      .then((res) => {
        const list = (res.data.data || []).filter((a) => !!a.metaCatalogId);
        setAdAccounts(list);
        if (list.length > 0) setSelectedAccount(list[0]);
      })
      .catch(() => setAdAccounts([]));
  }, [authToken]);

  useEffect(() => {
    if (!selectedAccount?.id || !selectedAccount?.metaCatalogId) return;
    setLoadingProducts(true);
    axios
      .get(`/ad-accounts/${selectedAccount.id}/catalogs/products?catalog_id=${encodeURIComponent(selectedAccount.metaCatalogId)}`, {
        headers: headers(),
      })
      .then((res) => {
        const items = res.data.data || [];
        setCatalogProducts(items);
        if (items.length > 0) {
          const first = items[0];
          setForm((f) => ({
            ...f,
            productRetailerId: first.retailer_id || "",
            productMetaId: first.id || "",
            catalogLandingUrl: first.url || f.catalogLandingUrl,
            name: f.name || `Campaign - ${(first.name || "").slice(0, 40)}`,
          }));
        }
      })
      .catch(() => setCatalogProducts([]))
      .finally(() => setLoadingProducts(false));
  }, [selectedAccount?.id, selectedAccount?.metaCatalogId]);

  const updateProductSelection = (retailerId) => {
    const p = catalogProducts.find((x) => String(x.retailer_id) === String(retailerId));
    setForm((f) => ({
      ...f,
      productRetailerId: retailerId,
      productMetaId: p?.id || "",
      catalogLandingUrl: p?.url || f.catalogLandingUrl,
      name: f.name || (p?.name ? `Campaign - ${p.name.slice(0, 40)}` : f.name),
    }));
  };

  const payload = () => ({
    name: form.name,
    metaCatalogId: selectedAccount.metaCatalogId,
    metaProductRetailerId: form.productRetailerId,
    metaProductId: form.productMetaId || undefined,
    budget: { daily: Number(form.dailyBudget) },
    targetAudience: {
      ageMin: Number(form.ageMin),
      ageMax: Number(form.ageMax),
      locations: form.locations.split(",").map((s) => s.trim()).filter(Boolean),
    },
    catalogLandingUrl: form.catalogLandingUrl || undefined,
    startDate: form.startDate || undefined,
    endDate: form.endDate || undefined,
  });

  const createCampaign = (e) => {
    e.preventDefault();
    if (!selectedAccount?.id || !selectedAccount?.metaCatalogId || !form.productRetailerId || !form.name) {
      toast.error(
        metaCampaignTranslations.pleaseSelectRequired[userLanguage] ||
          metaCampaignTranslations.pleaseSelectRequired.en
      );
      return;
    }
    setSubmitting(true);
    axios
      .post(`/ad-accounts/${selectedAccount.id}/campaigns`, payload(), { headers: headers() })
      .then(() => {
        toast.success(
          metaCampaignTranslations.campaignCreated[userLanguage] ||
            metaCampaignTranslations.campaignCreated.en
        );
        history.push("/seller/social-advertisement");
      })
      .catch((err) =>
        toast.error(
          err.response?.data?.message ||
            metaCampaignTranslations.campaignCreateFailed[userLanguage] ||
            metaCampaignTranslations.campaignCreateFailed.en
        )
      )
      .finally(() => setSubmitting(false));
  };

  const saveDraft = () => {
    if (!selectedAccount?.id || !selectedAccount?.metaCatalogId || !form.productRetailerId || !form.name) {
      toast.error(
        metaCampaignTranslations.pleaseSelectRequired[userLanguage] ||
          metaCampaignTranslations.pleaseSelectRequired.en
      );
      return;
    }
    setSavingDraft(true);
    axios
      .post(
        "/campaigns/draft",
        {
          name: form.name,
          adAccountRef: selectedAccount.id,
          metaCatalogId: selectedAccount.metaCatalogId,
          metaProductRetailerId: form.productRetailerId,
          metaProductId: form.productMetaId || undefined,
          budget: { daily: Number(form.dailyBudget) },
          targetAudience: {
            ageMin: Number(form.ageMin),
            ageMax: Number(form.ageMax),
            locations: form.locations.split(",").map((s) => s.trim()).filter(Boolean),
          },
          catalogLandingUrl: form.catalogLandingUrl || undefined,
          startDate: form.startDate || undefined,
          endDate: form.endDate || undefined,
        },
        { headers: headers() }
      )
      .then(() =>
        toast.success(
          metaCampaignTranslations.draftSaved[userLanguage] ||
            metaCampaignTranslations.draftSaved.en
        )
      )
      .catch((err) =>
        toast.error(
          err.response?.data?.message ||
            metaCampaignTranslations.draftSaveFailed[userLanguage] ||
            metaCampaignTranslations.draftSaveFailed.en
        )
      )
      .finally(() => setSavingDraft(false));
  };

  return (
    <div className="animated fadeIn">
      <ToastContainer autoClose={5000} />
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <b>
                {metaCampaignTranslations.pageTitle[userLanguage] ||
                  metaCampaignTranslations.pageTitle.en}
              </b>
            </CardHeader>
            <CardBody>
              <Form onSubmit={createCampaign}>
                <FormGroup>
                  <Label>
                    {metaCampaignTranslations.adAccount[userLanguage] ||
                      metaCampaignTranslations.adAccount.en}
                  </Label>
                  <Input
                    type="select"
                    value={selectedAccount?.id || ""}
                    onChange={(e) => {
                      const id = ev(e);
                      setSelectedAccount(adAccounts.find((a) => a.id === id) || null);
                    }}
                  >
                    {adAccounts.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.accountName || a.accountId} /{" "}
                        {metaCampaignTranslations.catalogLabel[userLanguage] ||
                          metaCampaignTranslations.catalogLabel.en}
                        : {a.metaCatalogId}
                      </option>
                    ))}
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label>
                    {metaCampaignTranslations.productFromCatalog[userLanguage] ||
                      metaCampaignTranslations.productFromCatalog.en}
                  </Label>
                  {loadingProducts ? (
                    <div>
                      <i className="fas fa-spinner fa-pulse" aria-hidden />{" "}
                      {metaCampaignTranslations.loadingCatalogProducts[userLanguage] ||
                        metaCampaignTranslations.loadingCatalogProducts.en}
                    </div>
                  ) : (
                    <Input
                      type="select"
                      value={form.productRetailerId}
                      onChange={(e) => updateProductSelection(ev(e))}
                    >
                      <option value="">
                        {metaCampaignTranslations.selectProduct[userLanguage] ||
                          metaCampaignTranslations.selectProduct.en}
                      </option>
                      {catalogProducts.map((p) => (
                        <option key={p.id} value={p.retailer_id || ""}>
                          {(p.name ||
                            metaCampaignTranslations.untitled[userLanguage] ||
                            metaCampaignTranslations.untitled.en)}{" "}
                          /{" "}
                          {metaCampaignTranslations.retailerId[userLanguage] ||
                            metaCampaignTranslations.retailerId.en}
                          : {p.retailer_id || "-"}
                        </option>
                      ))}
                    </Input>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label>
                    {metaCampaignTranslations.campaignName[userLanguage] ||
                      metaCampaignTranslations.campaignName.en}
                  </Label>
                  <Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: ev(e) }))} required />
                </FormGroup>

                <Row form>
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        {metaCampaignTranslations.dailyBudget[userLanguage] ||
                          metaCampaignTranslations.dailyBudget.en}
                      </Label>
                      <Input type="number" min={1} step={1} value={form.dailyBudget} onChange={(e) => setForm((f) => ({ ...f, dailyBudget: ev(e) }))} />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        {metaCampaignTranslations.ageMin[userLanguage] ||
                          metaCampaignTranslations.ageMin.en}
                      </Label>
                      <Input type="number" min={18} max={65} value={form.ageMin} onChange={(e) => setForm((f) => ({ ...f, ageMin: ev(e) }))} />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        {metaCampaignTranslations.ageMax[userLanguage] ||
                          metaCampaignTranslations.ageMax.en}
                      </Label>
                      <Input type="number" min={18} max={65} value={form.ageMax} onChange={(e) => setForm((f) => ({ ...f, ageMax: ev(e) }))} />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <Label>
                    {metaCampaignTranslations.locations[userLanguage] ||
                      metaCampaignTranslations.locations.en}
                  </Label>
                  <Input value={form.locations} onChange={(e) => setForm((f) => ({ ...f, locations: ev(e) }))} />
                </FormGroup>

                <Row form>
                  <Col md={6}>
                    <FormGroup>
                      <Label>
                        {metaCampaignTranslations.startDate[userLanguage] ||
                          metaCampaignTranslations.startDate.en}
                      </Label>
                      <Input type="date" value={form.startDate} onChange={(e) => setForm((f) => ({ ...f, startDate: ev(e) }))} />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>
                        {metaCampaignTranslations.endDate[userLanguage] ||
                          metaCampaignTranslations.endDate.en}
                      </Label>
                      <Input type="date" value={form.endDate} onChange={(e) => setForm((f) => ({ ...f, endDate: ev(e) }))} />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <Label>
                    {metaCampaignTranslations.landingUrl[userLanguage] ||
                      metaCampaignTranslations.landingUrl.en}
                  </Label>
                  <Input type="url" value={form.catalogLandingUrl} onChange={(e) => setForm((f) => ({ ...f, catalogLandingUrl: ev(e) }))} />
                </FormGroup>

                <Button type="submit" color="primary" disabled={submitting}>
                  {submitting
                    ? metaCampaignTranslations.creating[userLanguage] ||
                      metaCampaignTranslations.creating.en
                    : metaCampaignTranslations.createCampaign[userLanguage] ||
                      metaCampaignTranslations.createCampaign.en}
                </Button>
                <Button type="button" color="warning" className="ml-2" onClick={saveDraft} disabled={savingDraft}>
                  {savingDraft
                    ? metaCampaignTranslations.saving[userLanguage] ||
                      metaCampaignTranslations.saving.en
                    : metaCampaignTranslations.saveDraft[userLanguage] ||
                      metaCampaignTranslations.saveDraft.en}
                </Button>
                <Button type="button" color="secondary" className="ml-2" onClick={() => history.push("/seller/social-advertisement")}>
                  {metaCampaignTranslations.back[userLanguage] ||
                    metaCampaignTranslations.back.en}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MetaNewCampaign;

